import React from 'react';
import { Box } from '@mui/material';
import Header from './widgets/Header';
import ClicksList from './widgets/ClicksList';
import { useTranslation } from 'react-i18next';

function ClicksReport({ user }) {
    const { t } = useTranslation();
    return (
        <Box>
            <Header text={t('clicksReport.title')} />
            <ClicksList user={user} />
        </Box>
    );
}

export default ClicksReport;